import React, { useContext } from 'react'
import SectionAwards from '../sectionAwards/sectionAwards'
import './contentAwards.scss'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import BannerTitles from '../../molecules/bannerTitles/bannerTitles'
import useGetInscription from '../../../utils/hooks/useGetInscription'
import { Context } from '../../../context/app-context'
import { ambassadorSelectedDate } from '../../../constants/activity-constants'
import pushEventDataLayer from "../../../utils/pushEventDataLayer";

const ContentAwards = () => {
  const [isAmbassador, isLoading] = useGetInscription()
  const { dispatch } = useContext(Context)

  React.useEffect(() => {
    dispatch({ type: 'clear-modal' })
  }, [])

  const {
    BannerSignUpDesk: { childImageSharp: BannerSignUpDesk },
    BannerSignUpMob: { childImageSharp: BannerSignUpMob },
  } = useStaticQuery(graphql`
    {
      BannerSignUpDesk: file(name: { eq: "banner-inscribete-desk-per" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      BannerSignUpMob: file(name: { eq: "banner-inscribete-mob-per" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  return (
    <>
      <BannerTitles section="awards" />
      <SectionAwards section="awards" />
      <div className="f-banner-awards">
        {/* {isAmbassador ? ( */}
          {/* <div className="f-banner-awards__container ambassador">
            <div className="f-banner-awards__dates">
              <p>¡Ya caaaaasi!</p>
              <p>
                A partir del {ambassadorSelectedDate} te contaremos si fuiste
                seleccionada para ser parte de las Embajadoras Cur-V
              </p>
            </div>
            <GatsbyImage
              objectFit="cover"
              objectPosition="center top"
              image={withArtDirection(getImage(BannerDatesDesk), [
                {
                  media: '(max-width: 1024px)',
                  image: getImage(BannerDatesMob),
                },
              ])}
              alt="Aprende Más"
              className="f-banner-awards__image"
            />
          </div> */}
        {/* ) : ( */}
          <div
            className="f-banner-awards__container"
            onClick={() => {
              pushEventDataLayer({
                "event": 'Interacciones - retos',
                'category':'embajadoras-curv',
                "action": 'click',
                "label": 'INSCRÍBETE AHORA',
                "location": "nosotras.com/retos"

              })
              navigate('/retos')
            }}
          >
            <GatsbyImage
              objectFit="cover"
              objectPosition="center top"
              image={withArtDirection(getImage(BannerSignUpDesk), [
                {
                  media: '(max-width: 1024px)',
                  image: getImage(BannerSignUpMob),
                },
              ])}
              alt="Aprende Más"
              className="f-banner-awards__image"
            />
          </div>
        {/* )} */}
      </div>
    </>
  )
}

export default ContentAwards
